// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QbGA","col":"styles_col__svcBI"};